import { useSyncExternalStore } from 'react'

// The widget's open state, held outside it so MobileHeader's menu can open it and so
// Modal/FullscreenModal yield MUI's focus trap only while the panel is actually up.

let isOpen = false
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const getSnapshot = () => isOpen

const setFeedbackWidgetOpen = (open: boolean) => {
  if (isOpen === open) {
    return
  }
  isOpen = open
  listeners.forEach((listener) => listener())
}

export const openFeedbackWidget = () => setFeedbackWidgetOpen(true)

export const closeFeedbackWidget = () => setFeedbackWidgetOpen(false)

export const useIsFeedbackWidgetOpen = () => useSyncExternalStore(subscribe, getSnapshot)
